module.exports = __webpack_public_path__ + "static/media/javier-the-ceo.1bc000af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/leadership/javier-the-ceo.jpg
// module id = 296
// module chunks = 0